module.exports = "https://static.im-cdn.com/mjc/storefront/Anchor/static/media/ShareWhatsapp.b4e996a0.svg";